<div class="full-container" *ngIf="isDesktopScreen">
  <div class="img-container">
    <img class="ingood-logo" src="assets/img/ingood_vertical_negativo@2x.png" alt="ingood" />
    <img [src]="whiteHandIcon">
  </div>
  <div class="form-wrapper">
    <div class="arrow-container">
      <app-header [configuration]="headerConfiguration" (onClickButton)="handleBackClick()"></app-header>
    </div>
    <div class="form-header">
      <mat-divider></mat-divider>
      <div class="title">Datos personales</div>
    </div>
    <form [formGroup]="personalForm" (ngSubmit)="onSubmit()" class="form-content">
      <!-- DNI -->
      <label>DNI</label>
      <input formControlName="dni" type="text" maxlength="9" />
      <div class="error" *ngIf="personalForm.get('dni')?.touched && personalForm.get('dni')?.invalid">
        <div *ngIf="personalForm.get('dni')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="personalForm.get('dni')?.errors?.['invalidDniNie']">Formato inválido.</div>
      </div>

      <!-- Nombre -->
      <label>Nombre</label>
      <input formControlName="nombre" type="text" maxlength="50" />
      <div class="error" *ngIf="personalForm.get('nombre')?.touched && personalForm.get('nombre')?.invalid">
        <div *ngIf="personalForm.get('nombre')?.errors?.['required']">Campo requerido</div>
      </div>

      <!-- Apellidos -->
      <label>Apellidos</label>
      <input formControlName="apellidos" type="text" maxlength="50" />
      <div class="error" *ngIf="personalForm.get('apellidos')?.touched && personalForm.get('apellidos')?.invalid">
        <div *ngIf="personalForm.get('apellidos')?.errors?.['required']">Campo requerido</div>
      </div>

      <!-- Fecha de nacimiento -->
      <label>Fecha de nacimiento</label>
      <mat-form-field class="custom-datepicker">
        <input matInput [matDatepicker]="picker" formControlName="fechaNacimiento" placeholder="dd/mm/aaaa"
          [max]="maxDate" readonly (click)="picker.open()"/>
        <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
        <mat-datepicker id="picker" #picker startView="multi-year" [touchUi]="true"></mat-datepicker>
      </mat-form-field>
      <div class="error"
        *ngIf="personalForm.get('fechaNacimiento')?.touched && personalForm.get('fechaNacimiento')?.invalid">
        <div *ngIf="personalForm.get('fechaNacimiento')?.errors?.['required']">Campo requerido</div>
      </div>

      <!-- Dirección -->
      <label>Dirección</label>
      <app-input-google [formGroup]="personalForm" *ngIf="personalForm" [formFieldConfig]="formFieldsArray"
        [fieldsArr]="fieldsArr">
      </app-input-google>
      <div class="error" *ngIf="personalForm.get('direccion')?.touched && personalForm.get('direccion')?.invalid">
        <div *ngIf="personalForm.get('direccion')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="personalForm.get('direccion')?.errors?.['pattern']">Formato inválido. Usa: Calle, Número, Provincia,
          CP</div>
      </div>

      <!-- Email -->
      <label>Email</label>
      <input formControlName="Email" type="text" maxlength="64" />
      <div class="error" *ngIf="personalForm.get('Email')?.touched && personalForm.get('Email')?.invalid">
        <div *ngIf="personalForm.get('Email')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="personalForm.get('Email')?.errors?.['email']">Formato de email inválido</div>
      </div>

      <!-- SUGERENCIA EMAIL -->
      <div class="email-suggestion" *ngIf="emailSuggestion" (click)="applyEmailSuggestion()">
        ¿Quieres decir <strong>{{ emailSuggestion }}</strong>?
      </div>

      <!-- Teléfono -->
      <label>Teléfono</label>
      <input formControlName="Telefono" type="text" maxlength="9" />
      <div class="error" *ngIf="personalForm.get('Telefono')?.touched && personalForm.get('Telefono')?.invalid">
        <div *ngIf="personalForm.get('Telefono')?.errors?.['required']">Campo requerido</div>
        <div *ngIf="personalForm.get('Telefono')?.errors?.['pattern']">Formato inválido. Debe contener 9 dígitos</div>
      </div>


      <button type="submit" class="continue-button" [disabled]="isContinueDisabled"
        [class.disabled]="isContinueDisabled">Continuar</button>
    </form>

  </div>
</div>

<div class="mobile-container" *ngIf="!isDesktopScreen">
  <div class="arrow-container">
    <app-header [configuration]="headerConfiguration" (onClickButton)="handleBackClick()"></app-header>
    <img class="ingood-logo" src="assets/img/ingood_vertical_negativo@2x.png" alt="ingood" />
  </div>
  <div class="form-header">
    <mat-divider></mat-divider>
    <div class="title">Datos personales</div>
  </div>
  <div class="full-container">
    <div class="form-wrapper">
      <form [formGroup]="personalForm" (ngSubmit)="onSubmit()" class="form-content">

        <!-- DNI -->
        <label>DNI</label>
        <input formControlName="dni" type="text" maxlength="9" />
        <div class="error" *ngIf="personalForm.get('dni')?.touched && personalForm.get('dni')?.invalid">
          <div *ngIf="personalForm.get('dni')?.errors?.['required']">Campo requerido</div>
          <div *ngIf="personalForm.get('dni')?.errors?.['invalidDniNie']">Formato inválido.</div>
        </div>

        <!-- Nombre -->
        <label>Nombre</label>
        <input formControlName="nombre" type="text" maxlength="50" />
        <div class="error" *ngIf="personalForm.get('nombre')?.touched && personalForm.get('nombre')?.invalid">
          <div *ngIf="personalForm.get('nombre')?.errors?.['required']">Campo requerido</div>
        </div>

        <!-- Apellidos -->
        <label>Apellidos</label>
        <input formControlName="apellidos" type="text" maxlength="50" />
        <div class="error" *ngIf="personalForm.get('apellidos')?.touched && personalForm.get('apellidos')?.invalid">
          <div *ngIf="personalForm.get('apellidos')?.errors?.['required']">Campo requerido</div>
        </div>

        <!-- Fecha de nacimiento -->
        <label>Fecha de nacimiento</label>
        <mat-form-field class="custom-datepicker">
          <input matInput [matDatepicker]="picker" formControlName="fechaNacimiento" placeholder="dd/mm/aaaa"
            [max]="maxDate" readonly (click)="picker.open()"/>
          <mat-datepicker-toggle matIconSuffix [for]="picker"></mat-datepicker-toggle>
          <mat-datepicker id="picker" #picker startView="multi-year" [touchUi]="true"></mat-datepicker>
        </mat-form-field>
        <div class="error"
          *ngIf="personalForm.get('fechaNacimiento')?.touched && personalForm.get('fechaNacimiento')?.invalid">
          <div *ngIf="personalForm.get('fechaNacimiento')?.errors?.['required']">Campo requerido</div>
        </div>

        <!-- Direccion -->
        <label>Dirección</label>
        <app-input-google [formGroup]="personalForm" *ngIf="personalForm" [formFieldConfig]="formFieldsArray"
          [fieldsArr]="fieldsArr">
        </app-input-google>
        <div class="error" *ngIf="personalForm.get('direccion')?.touched && personalForm.get('direccion')?.invalid">
          <div *ngIf="personalForm.get('direccion')?.errors?.['required']">Campo requerido</div>
          <div *ngIf="personalForm.get('direccion')?.errors?.['pattern']">Formato inválido. Usa: Calle, Número,
            Provincia,
            CP</div>
        </div>

        <!-- Email -->
        <label>Email</label>
        <input formControlName="Email" type="email" autocorrect="off" autocapitalize="none" maxlength="64" />
        <div class="error" *ngIf="personalForm.get('Email')?.touched && personalForm.get('Email')?.invalid">
          <div *ngIf="personalForm.get('Email')?.errors?.['required']">Campo requerido</div>
          <div *ngIf="personalForm.get('Email')?.errors?.['email']">Formato de email inválido</div>
        </div>

        <!-- SUGERENCIA EMAIL -->
        <div class="email-suggestion" *ngIf="emailSuggestion" (click)="applyEmailSuggestion()">
          ¿Quieres decir <strong>{{ emailSuggestion }}</strong>?
        </div>

        <!-- Teléfono -->
        <label>Teléfono</label>
        <input formControlName="Telefono" type="text" maxlength="9" />
        <div class="error" *ngIf="personalForm.get('Telefono')?.touched && personalForm.get('Telefono')?.invalid">
          <div *ngIf="personalForm.get('Telefono')?.errors?.['required']">Campo requerido</div>
          <div *ngIf="personalForm.get('Telefono')?.errors?.['pattern']">Formato inválido. Debe contener 9 dígitos</div>
        </div>

        <button type="submit" class="continue-button" [disabled]="isContinueDisabled"
          [class.disabled]="isContinueDisabled">Continuar</button>
      </form>

    </div>
  </div>
</div>